import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { QuestionModel } from '../model/question.model';

@Injectable()
export class QuestionService {

    path = '/question';

    constructor(private baseService: BaseService) {}

    findByQuestionGroupId(questionGroupId: number) {
        return this.baseService.get(this.path, '/' + questionGroupId);
    }

    findUnconformities(questionId: number) {
        return this.baseService.get(this.path, '/' + questionId + '/unconformities')
    }

    save(question: QuestionModel) {
        if (question.id) { return this.put(question); } else { return this.post(question); }
    }

    post(question: QuestionModel) {
        return this.baseService.post(this.path, '/', question);
    }

    put(question: QuestionModel) {
        return this.baseService.put(this.path, '/', question);
    }

    delete(id: number) {
        return this.baseService.delete(this.path, '/' + id);
    }

    addUnconformities(data) {
        return this.baseService.post(this.path, '/' + data.id + '/unconformities', data);
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/question.service.ts